import React from 'react'

const Profile = () => {
  return (
    <div className='mt-20 text-center font-bold text-2xl'>
     Admin Profile
    </div>
  )
}

export default Profile
